import { cn } from '@/lib/utils/cn';

/**
 * Page layout helper. AppShell's `<main>` is a height-constrained flex
 * column (no page-level scroll) so each page decides how to use the
 * space it owns. Pick the right variant for the content shape:
 *
 *  - `<FillPage>`     fixed viewport, content fills available height.
 *                     Used by list pages where the DataTable should
 *                     claim flex-1 + handle its own internal scroll.
 *
 *  - `<ScrollPage>`   the page's own content scrolls vertically (sticky
 *                     children inside will not pin to the viewport).
 *                     Use for forms / dashboards / profile cards.
 */

const PADDING = 'px-4 py-6 lg:px-8';
const WIDTH = 'mx-auto w-full max-w-[1400px]';

export function FillPage({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn('flex min-h-0 flex-1 flex-col', PADDING)}>
      <div className={cn(WIDTH, 'flex min-h-0 flex-1 flex-col gap-4', className)}>
        {children}
      </div>
    </div>
  );
}

export function ScrollPage({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn('min-h-0 flex-1 overflow-y-auto', PADDING)}>
      <div className={cn(WIDTH, 'space-y-4', className)}>{children}</div>
    </div>
  );
}
